// src/components/Footer/Footer.js
import React from 'react';
import './Footer.css';
import Logo from '../../../src/assets/images/smashes-logo.png';

const Footer = () => {
  const waNumber = '529994982533';
  const waMessage = encodeURIComponent(
    'Hola Smashes Store 👋 Quiero cotizar un perfume. ¿Me ayudas por favor?'
  );
  const whatsappUrl = `https://wa.me/${waNumber}?text=${waMessage}`;

  return (
    <footer className="footer-min">
      <div className="footer-min__inner">
        <div className="footer-min__brand">
          <img className="footer-min__logo" src={Logo} alt="Smashes Store" />
          <div className="footer-min__text">
            <div className="footer-min__name">Smashes Store</div>
            <div className="footer-min__desc">Perfumes 100% originales y completos.</div>
          </div>
        </div>

        <div className="footer-min__links">
          <a
            className="footer-min__link footer-min__link--wa"
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            WhatsApp
          </a>

          <span className="footer-min__dot">•</span>

          <a
            className="footer-min__link footer-min__link--fb"
            href="https://www.facebook.com/profile.php?id=61560818762830"
            target="_blank"
            rel="noopener noreferrer"
          >
            Facebook
          </a>
        </div>

        <div className="footer-min__note">
          Tip: envíanos el nombre del perfume y la presentación (ml).
        </div>

        <div className="footer-min__copy">
          © {new Date().getFullYear()} Smashes Store
        </div>
      </div>
    </footer>
  );
};

export default Footer;
